import React, { useState } from 'react';
import { useSite } from '../../context/SiteContext';
import { useAuth } from '../../context/AuthContext';
import { Heart, Clock } from 'lucide-react';

export default function RightSidebar({ onLogin }) {
  const { data } = useSite();
  const { user } = useAuth();
  const r = data.rightPanel || {};
  const [tab, setTab] = useState('interests');

  return (
    <div className="rounded-xl bg-zinc-950/60 border border-zinc-900 overflow-hidden">
      <div className="p-2 flex gap-1">
        <button onClick={() => setTab('interests')} className={`flex-1 h-9 rounded-md text-sm font-bold transition-colors flex items-center justify-center gap-1.5 ${
          tab === 'interests' ? 'bg-[color:var(--gold)] text-black' : 'bg-zinc-900 text-zinc-300 hover:bg-zinc-800'
        }`}>
          <Heart size={13} /> {r.tab1Label}
        </button>
        <button onClick={() => setTab('recent')} className={`flex-1 h-9 rounded-md text-sm font-bold transition-colors flex items-center justify-center gap-1.5 ${
          tab === 'recent' ? 'bg-[color:var(--gold)] text-black' : 'bg-zinc-900 text-zinc-300 hover:bg-zinc-800'
        }`}>
          <Clock size={13} /> {r.tab2Label}
        </button>
      </div>
      <div className="px-4 py-6 min-h-[260px] flex items-center justify-center text-center">
        {user ? (
          <div className="w-full space-y-2">
            {(user.interests || []).length === 0 ? (
              <p className="text-zinc-400 text-sm">No saved interests yet. Submit interest on any platform to see it here.</p>
            ) : (
              user.interests.slice(-5).reverse().map((it) => (
                <div key={it.id} className="text-left bg-zinc-900/60 border border-zinc-800 rounded-md p-2.5">
                  <div className="text-white text-sm font-semibold capitalize">{it.type}</div>
                  {it.platform && <div className="text-zinc-400 text-xs">{it.platform}</div>}
                </div>
              ))
            )}
          </div>
        ) : (
          <p className="text-zinc-300 text-sm">
            {r.emptyText || 'Save your favorite platforms and services to access them quickly.'}
            {data.header?.showLogin !== false && r.loginLink && (
              <>
                {' '}
                <button onClick={onLogin} className="text-[color:var(--gold)] font-semibold hover:underline">{r.loginLink}</button>
              </>
            )}
          </p>
        )}
      </div>
    </div>
  );
}
